import { IIconProps } from "../types"

export default function IconLL7(props: IIconProps) {
  const width = props.size || props.width || (99 / 5) * 3
  const height = props.size || props.height || (78 / 5) * 3
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 99 78"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M86.5553 2.54421C84.7059 1.58452 82.3466 0.704802 79.3976 0.494869C76.4685 0.294933 72.9497 0.774779 69.5208 1.48455C66.1018 2.20432 62.7729 3.15402 58.8042 3.87379C54.8355 4.58356 50.2269 5.0634 45.1386 4.89346C40.0502 4.72351 34.472 3.90378 30.5333 3.32396C26.5945 2.74415 24.2952 2.40426 22.2659 2.84412C20.2366 3.29397 18.4771 4.51358 16.3878 5.54325C14.2985 6.56292 11.8792 7.38266 9.7799 8.16241C7.69057 8.95216 5.94113 9.70192 4.51159 11.5413C3.09205 13.3807 2.0024 16.3098 1.28263 19.4788C0.562858 22.6478 0.222967 26.0467 0.612842 31.5949C1.00272 37.1531 2.14235 44.8606 2.9221 51.0986C3.69185 57.3366 4.12172 62.1051 5.24136 65.684C6.361 69.2628 8.18042 71.6521 10.8795 73.2815C13.5687 74.921 17.1475 75.8107 22.5358 76.3805C27.9341 76.9704 35.1418 77.2403 43.779 77.3402C52.4062 77.4402 62.463 77.3702 69.1009 77.1403C75.7388 76.9004 78.9477 76.4905 81.277 75.7707C83.6162 75.061 85.0658 74.0313 86.1854 72.7417C87.315 71.4421 88.0948 69.8826 90.0642 63.6446C92.0335 57.4066 95.1825 46.5001 96.672 39.3124C98.1516 32.1247 97.9716 28.6458 97.4918 25.3369C97.0019 22.038 96.2222 18.899 95.0926 15.63C93.9729 12.3611 92.5234 8.95216 91.1238 6.73287C89.7343 4.51358 88.4047 3.49391 86.5553 2.54421Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.899712"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
